module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"empty":"No activity yet."},"fr":{"empty":"Il n\u0027y a pas encore d\u0027activité."}}')
  delete Component.options._Ctor
}
